export default __webpack_public_path__ + "static/media/313.f5d33410.gif";